<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" src="../styles/main.scss"></style>
<template src="./templates/payment-methods.html"></template>

<script>
import rmaccordion from '../components/rm-accordion'
import rmbutton from '../components/rm-button'
import rminput from '../components/rm-input'
export default {
  name: 'PaymentMethods',
  components: {
    'rm-accordion': rmaccordion,
    'rm-button': rmbutton,
    'rm-input': rminput
  },
  data () {
    const dynamicAction = () => {
        console.log('Dynamic Action')
    }
    return {
      creditCards: [],
      simpleList: [
          { title: 'Introduction', content: 'test <b>1</b> content', collapse: true },
          { title: 'Payment', content: 'test <i>2</i> content', collapse: true },
          { title: 'Button Component', component: 'rm-button', props: { label: 'Dynamic Btn', action: dynamicAction }, collapse: true },
          { title: 'Input Component', component: 'rm-input', props: { }, collapse: true }
        ]
    }
  },
  mounted () {
    let vm = this
    vm.BillingService(vm).getCreditCards().then((data) => {
      console.log(data)
      vm.creditCards = data
    }).catch((error) => {
      console.log(error)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/PaymentMethods.vue